// extracted by mini-css-extract-plugin
export default {"root":"NatRulesIpInfo_root__eVkdW","verticalAlign":"NatRulesIpInfo_verticalAlign__U8ZvU","targetField":"NatRulesIpInfo_targetField__mlP4W"};